import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SnackAlert from '../../../Common/Alerts';
import Spinner from '../../../Common/Spinner';
import { Layout } from '../../../components/SidebarHeaderWrapper';
import { Box, Button, Dialog, DialogActions, DialogTitle, Grid, Slide, Tab, Tabs, Typography } from '@mui/material';
import PurchasePermits from './PurchasePermits';
import PermitsHistory from './PermitsHistory';
import permitServices from '../../../services/permit-service';
import moment from 'moment';
import stripeServices from '../../../services/stripe-service';
import Receipt from './Receipt';
import { useSearchParams } from 'react-router-dom';
import Moneris from './Moneris';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3, width: '100%', placeSelf: 'start' }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

export default function Permits(props) {
    const [searchParams] = useSearchParams();
    const [showSpinner, setShowSpinner] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [severity, setSeverity] = useState('');
    const [inputField, setInputField] = useState({});
    const [selectedZone, setSelectedZone] = useState(null)
    const [selectedPermit, setSelectedPermit] = useState(null)
    const [permitVal, setPermitVal] = useState({})
    const [showPayment, setShowPayment] = useState(false);
    const [history, setHistory] = useState([]);
    const [permits, setPermits] = useState([]);
    const [zones, setZones] = useState([]);
    const [tabValue, setTabValue] = useState(props.literals.buy_permit);
    const [paymentIntent, setPaymentIntent] = useState({});
    const [noOfMonthYear, setNoOfMonthYear] = useState([]);
    const [showReciept, setShowReceipt] = useState(false);
    const [parking, setParking] = useState({});
    const [limitexceedMsg, setLimitexceedMsg] = useState('');
    const [showPlateModal, setShowPlateModal] = useState(false);
    const [plate, setPlate] = useState('');
    const [editParking, setEditParking] = useState({});
    const [paymentGateway, setPaymentGateway] = useState('');
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [cancelPermitId, setCancelPermitId] = useState(null);

    useEffect(() => {
        getUserPermits();
        getPermits();
    }, [])

    const getPermits = async () => {
        setShowSpinner(true);
        const res = await permitServices.getPermits({ org_id: props.org._id });
        setZones(res.data)
        const permitId = searchParams.get("permit");
        const zoneId = searchParams.get("zone");
        const plate = searchParams.get("plate");
        if (permitId && zoneId && plate) {
            const zone = res.data.find(x => x._id === zoneId);
            setSelectedZone(zone);
            onZoneSelected(zone);
            setSelectedPermit(zone.permits?.find(x => x._id === permitId));
            onPermitSelect(zone.permits?.find(x => x._id === permitId));
            setInputField({ ...inputField, plate: plate.toUpperCase() });
        }
        setShowSpinner(false);
    }

    const getUserPermits = async () => {
        setShowSpinner(true);
        let user = JSON.parse(sessionStorage.getItem("userLogged"));
        if (user !== null) {
            const res = await permitServices.getUserPermits({ user_id: user.result._id });
            setHistory(res.data)
        }
        setShowSpinner(false);
    }

    const getTransactionDetail = async (e, index) => {
        setShowSpinner(true);
        const res = await permitServices.getTransactionDetail({ parking_id: e._id });
        let transaction = [...history];
        transaction[index].transactions = res.data;
        setHistory(transaction);
        setShowSpinner(false);
    }

    const handleChange = (e) => {
        setInputField({ ...inputField, [e.target.name]: e.target.name == 'plate' ? e.target.value.toUpperCase() : e.target.value });
        setShowPayment(false)
    };

    const handleCheck = (e) => {
        setInputField({ ...inputField, [e.target.name]: e.target.checked });
    };

    const onZoneSelected = async (e) => {
        setSelectedZone(e);
        setSelectedPermit(null);
        setPermits(e?.permits || []);
    }

    const onPermitSelect = async (e) => {
        let permit = { ...e };
        console.log(permit, e)
        setShowPayment(false)
        setLimitexceedMsg('');
        setInputField({ ...inputField, 'allow_auto_renew': false });
        // e.from = moment().format('MMMM Do YYYY, hh:mm a');
        if (permit.permit_type == 'yearly') {
            let noOfYears = [];
            for (let i = 0; i < permit.no_of_months_year; i++) {
                const year = moment().add(i, 'years');
                noOfYears.push({
                    value: i == 0 ? moment().startOf('year').format('MMMM Do YYYY, hh:mm a') : year.startOf('year').format('MMMM Do YYYY, hh:mm a'),
                    label: year.format('YYYY')
                })
            }
            setNoOfMonthYear(noOfYears);
            permit.from = moment().startOf('year').format('MMMM Do YYYY, hh:mm a');
            permit.to = moment().endOf('year').format('MMMM Do YYYY, hh:mm a');
        } else if (permit.permit_type == 'monthly') {
            let noOfMonths = [];
            for (let i = 0; i < permit.no_of_months_year; i++) {
                const month = moment().add(i, 'months');
                noOfMonths.push({
                    value: i == 0 ? moment().startOf('month').format('MMMM Do YYYY, hh:mm a') : month.startOf('month').format('MMMM Do YYYY, hh:mm a'),
                    label: month.format('MMMM')
                })
            }
            setNoOfMonthYear(noOfMonths);
            permit.from = moment().startOf('month').format('MMMM Do YYYY, hh:mm a');
            permit.to = moment().endOf('month').format('MMMM Do YYYY, hh:mm a');
            if (moment().date() > 15 && permit.semi_rate) {
                permit.rate = permit.semi_rate;
                permit.from = moment().startOf('month').add(15, 'days').format('MMMM Do YYYY, hh:mm a');
            }
        } else if (permit.permit_type == 'custom') {
            permit.from = moment(permit.permit_start_date).format('MMMM Do YYYY, hh:mm a');
            permit.to = moment(permit.permit_end_date).format('MMMM Do YYYY, hh:mm a');
        }
        permit.end_on = calculateDay(moment(permit.from, 'MMMM Do YYYY, hh:mm a').format(), moment(permit.to, 'MMMM Do YYYY, hh:mm a').format());
        permit.next_renew_at = moment(permit.to, "MMMM Do YYYY, hh:mm a").subtract(permit.renew_before, "days").format('MMMM Do YYYY, hh:mm a');
        if (permit.auto_renew_permission == 'restrict_auto_renew') {
            setInputField({ ...inputField, 'allow_auto_renew': true });
        }
        setSelectedPermit(e);
        setShowSpinner(true);
        if (permit.enable_permit_limit) {
            const res = await permitServices.checkPermitLimit({ permit: permit._id });
            if (res.data.msg) {
                setPermitVal({ ...permit, sold_out: true });
                setLimitexceedMsg(props.literals[res.data.msg]);
            } else {
                setPermitVal(permit);
            }
        } else
            setPermitVal(permit);
        setShowSpinner(false);
    }

    const calculateDay = (start_date, added_date) => {
        var fromNow = moment(added_date).from(start_date);
        return moment(added_date).calendar(null, {
            lastWeek: '[Last] dddd',
            lastDay: '[Yesterday]',
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: 'dddd',
            sameElse: function () {
                return "[" + fromNow + "]";
            }
        });
    }

    const onMonthYearSelect = (e) => {
        let rate = selectedPermit.rate;
        let from = e;
        if (selectedPermit.permit_type == 'monthly' && moment(e, 'MMMM Do YYYY, hh:mm a').isSame(moment(), "month") && moment().date() > 15 && selectedPermit.semi_rate) {
            rate = selectedPermit.semi_rate;
            from = moment(e, 'MMMM Do YYYY, hh:mm a').add(15, 'days').format('MMMM Do YYYY, hh:mm a');
        }
        const to = moment(e, 'MMMM Do YYYY, hh:mm a').endOf(selectedPermit.permit_type == 'monthly' ? 'month' : 'year').format('MMMM Do YYYY, hh:mm a');
        setPermitVal({
            ...selectedPermit,
            rate: rate,
            from: from,
            to: to,
            end_on: calculateDay(moment(from, 'MMMM Do YYYY, hh:mm a').format(), moment(to, 'MMMM Do YYYY, hh:mm a').format()),
            next_renew_at: moment(to, "MMMM Do YYYY, hh:mm a").subtract(selectedPermit.renew_before, "days").format('MMMM Do YYYY, hh:mm a')
        })
    }

    const purchaseParking = async (e) => {
        e.preventDefault();
        if(permitVal.rate == '0'){
            buyZeroPermit();
            return;
        }
        if (selectedZone.organization[0].payment_gateway == 'moneris') {
            setPaymentGateway('moneris');
            return;
        }
        setShowSpinner(true);
        const res = await stripeServices.secret({ org_id: selectedZone.organization[0]._id, plate: inputField.plate });
        if (res.data.msg) {
            setAlertMessage(res.data.msg);
            setSeverity('error');
            setShowAlert(true);
        } else {
            setPaymentIntent(res.data);
            setShowPayment(true)
        }
        setShowSpinner(false);
    }

    const onEditParking = async (e) => {
        e.preventDefault();
        setShowSpinner(true);
        const res = await permitServices.editPermitPlate({ id: editParking._id, plate: plate });
        if (res.data.msg) {
            setAlertMessage(res.data.msg);
            setSeverity('error');
            setShowAlert(true);
        } else {
            let transaction = [...history];
            transaction[editParking.index].plate = res.data.plate;
            setHistory(transaction);
            setShowPlateModal(false);
            setAlertMessage(props.literals.plate_updated_successfully);
            setSeverity('success');
            setShowAlert(true);
        }
        setShowSpinner(false);
    }

    const getTotalAmount = (amount, taxes) => {
        if (taxes?.length) {
            taxes.map(x => {
                amount = x.tax_included ? amount : amount + amount * x.tax_percentage / 100;
            })
            return Math.round(amount)
        } else
            return Math.round(amount)
    }

    const buyZeroPermit = async () => {
        setShowSpinner(true);
        let user = JSON.parse(sessionStorage.getItem("userLogged"));
        let body = {
            paymentMethod: '',
            paymentIntent: '',
            payment_gateway: 'stripe',
            amount: getTotalAmount(permitVal.rate, selectedZone.taxes),
            plate: inputField.plate,
            user: user.result._id,
            zone: selectedZone,
            city: selectedZone.city_id,
            from: permitVal.from,
            to: permitVal.to,
            coord: '',
            service_fee: 0,
            org: props.org._id,
            permit: permitVal._id,
            next_renew_at: permitVal.next_renew_at,
            allow_auto_renew: inputField.allow_auto_renew,
            source: "webPermit"
        }
        const res = await permitServices.buyPermit(body);
        setShowSpinner(false);
        if (!res.data.message) {
            setShowReceipt(true);
            setParking(res.data)
        } else {
            setAlertMessage(res.data.message);
            setSeverity('error');
            setShowAlert(true);
        }
    }

    const cancelPermit = async () => {
        setShowSpinner(true);
        const res = await permitServices.unsubscribePermit({transaction_id: cancelPermitId.id});
        setShowSpinner(false);
        if (res.data.status == 'error') {
            setAlertMessage(res.data.message);
            setSeverity('error');
            setShowAlert(true);
            return;
        }
        setAlertMessage('Auto renewal disabled successfully');
        setSeverity('success');
        setShowAlert(true);
        let transaction = [...history];
        transaction[cancelPermitId.historyIndex].transactions[cancelPermitId.transactionIndex].allow_auto_renew = res.data?.allow_auto_renew;
        setHistory(transaction);
        setOpenConfirmDialog(false);
    }

    return (
        <>
            <Layout org={props.org} literals={props.literals}>
                <Box sx={{ width: '100%' }}>
                    {!showReciept &&
                        <Box sx={{ width: '100%' }}>
                            <Tabs
                                value={tabValue}
                                onChange={(event, newValue) => { setTabValue(newValue) }}
                            >
                                <Tab value={props.literals.buy_permit} label={props.literals.buy_permit} />
                                <Tab value={props.literals.history} label={props.literals.history} />
                            </Tabs>
                            <CustomTabPanel value={tabValue} index={props.literals.buy_permit}>
                                {paymentGateway !== 'moneris' && <PurchasePermits
                                    org={props.selectedZone?.organization?.length ? props.selectedZone?.organization[0] : props.org}
                                    literals={props.literals}
                                    zones={zones}
                                    permits={permits}
                                    inputField={inputField}
                                    selectedZone={selectedZone}
                                    selectedPermit={selectedPermit}
                                    permitVal={permitVal}
                                    showPayment={showPayment}
                                    paymentIntent={paymentIntent}
                                    noOfMonthYear={noOfMonthYear}
                                    limitexceedMsg={limitexceedMsg}

                                    onMonthYearSelect={(e) => onMonthYearSelect(e)}
                                    onZoneSelected={(e) => onZoneSelected(e)}
                                    onPermitSelect={(e) => onPermitSelect(e)}
                                    handleCheck={(e) => handleCheck(e)}
                                    handleChange={(e) => handleChange(e)}
                                    purchaseParking={(e) => purchaseParking(e)}
                                    showReciept={() => setShowReceipt(true)}
                                    setParking={(e) => setParking(e)}
                                    getTotalAmount={(e, taxes) => getTotalAmount(e, taxes)}
                                />}
                                {paymentGateway === 'moneris' && <Moneris
                                    permitVal={permitVal}
                                    totalAmount={getTotalAmount(permitVal.rate, selectedZone.taxes)}
                                    inputField={inputField}
                                    org={selectedZone.organization[0]}
                                    selectedZone={selectedZone}

                                    back={() => setPaymentGateway('')}
                                    showReciept={() => setShowReceipt(true)}
                                    setParking={(e) => setParking(e)}
                                />
                                }
                            </CustomTabPanel>
                            <CustomTabPanel value={tabValue} index={props.literals.history}>
                                <PermitsHistory
                                    literals={props.literals}
                                    history={history}
                                    showPlateModal={showPlateModal}
                                    plate={plate}

                                    setPlate={(e) => setPlate(e)}
                                    getTransactionDetail={(e, index) => getTransactionDetail(e, index)}
                                    onEdit={(e, index) => { setShowPlateModal(true); setEditParking({ ...e, index: index }) }}
                                    onEditParking={(e) => onEditParking(e)}
                                    setShowPlateModal={(e) => { setShowPlateModal(e) }}
                                    openConfirmDialog={(e) => { setOpenConfirmDialog(true); setCancelPermitId(e) }}
                                />
                            </CustomTabPanel>
                        </Box>
                    }
                    {showReciept &&
                        <Box sx={{ width: '100%' }}>
                            <Receipt
                                literals={props.literals}
                                permitVal={permitVal}
                                totalAmount={getTotalAmount(permitVal.rate, selectedZone.taxes)}
                                inputField={inputField}
                                org={props.org}
                                selectedZone={selectedZone}
                                parking={parking}
                            />
                        </Box>
                    }
                </Box>
                {/* {props.org.payment_gateway !== "stripe" && <Box sx={{ width: '100%', pt: 5 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} align='center'>
                            <Typography variant='h4' sx={{ color: '#b20b01', border: '1px solid #b20b01', padding: '10px 15px', borderRadius: '20px', background: '#b20b0117', placeSelf: 'center' }} >
                                {props.literals.service_not_available}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>} */}
                <SnackAlert
                    alertMessage={alertMessage}
                    showAlert={showAlert}
                    severity={severity}

                    closeAlert={() => setShowAlert(!showAlert)}
                />
                <Spinner
                    spinner={showSpinner}
                />
                <Dialog
                    open={openConfirmDialog}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setOpenConfirmDialog(false)}
                    aria-describedby="alert-dialog-slide-description"
                    >
                    <DialogTitle>{"Are you sure you want to disable auto renewal for this permit?"}</DialogTitle>
                    <DialogActions>
                        <Button onClick={() => setOpenConfirmDialog(false)} sx={{color: '#454545'}}>Cancel</Button>
                        <Button onClick={()=> cancelPermit()} variant="contained" color="secondary">Yes</Button> 
                    </DialogActions>
                </Dialog>
            </Layout>
        </>
    );
}